import React, { useState } from "react";
// import {Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
  FormGroup,
  Label,
  Form,
  Input
} from "reactstrap";
import classnames from "classnames";
import { loginApi, registerApi } from "../redux/actions/api/apiAction";
import { store } from "../redux/storeConfig/store";
import { toastr } from "react-redux-toastr";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import GoogleLogin from "react-google-login";

// const formSchema = Yup.object().shape({
//   firstName: Yup.string().max(30, 'cannot be > 30 characters').required("First name is required"),
//   lastName: Yup.string().max(30, 'cannot be > 30 characters').required("Last name is required"),
//   phone: Yup.number().required("Phone is required"),
//   password : Yup.string().min(5, 'cannot be < 5 characters').required("Password is required"),
//   email: Yup.string()
//     .email()
//     .required("Email is required"),
//   // gender: Yup.string().required('Gender is required'),
//   term: Yup.boolean().required("Please accept terms and conditions"),
// });

const Example = props => {
  const [activeTab, setActiveTab] = useState("1");
  const [eye, setEye] = useState(false);
  const [disabled, setDisable] = useState(false);
  const [phone, setPhone] = useState("");

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleEye = () => {
    setEye(!eye);
  };

  const loginSubmit = async (email, password) => {
    await store.dispatch(loginApi({ email: email, password: password }));
  };

  const registerSubmit = async data => {
    delete data.acceptedTerm;
    data.name = `${data.firstName} ${data.lastName}`;
    // console.log(data);
    await store.dispatch(registerApi(data));
  };

  const responseGoogle = async response => {
    setDisable(true);
    // console.log("Google Response", response.profileObj)
    // const { email, googleId } = response.profileObj;
    // const headers = { "Content-Type": "application/json" };
    // const data = { email, password: googleId };
    // try {
    //   const response = await axios.post(`${url}/user/login`, data, { headers });
    //   if (response.status === 200) {
    //     Cookies.set("user", response.data.user, { expires: 365 });
    //     await setOnline(response.data.user.chatId);
    //     this.setState({ disabled: false });
    //     toast.success(this.props.t("login_success"));
    //     if(response.data.user.createdBy === "admin"){
    //       Cookies.set("firstTimeLogin", true);
    //       }
    //     response.data.user.createdBy === "admin"
    //       ? Router.replace("/createnewpassword")
    //       : response.data.user.role === "a"
    //       ? Router.replace("/")
    //       : Router.replace("/eventorganizationprofile");
    //   }
    // } catch (error) {
    //   this.setState({ disabled: false });
    //   toast.error(error.response.data.message);
    // }
  };

  return (
    <div className="login-register">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            {props.t("register")}{" "}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
            {props.t("login")}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          {/* <div className="social-media-btn input-content-form ">
            <h5>{props.t("login_using_social_media")}</h5>
            <div className="social-media-icon-tab">
              <ul className="social-media-icon-block text-center">
                <li className="social-media-icon-btn">
                <GoogleLogin
                  clientId="AIzaSyAUHbF41YA6IPfTCsgCAoqBa5p9auujeAQ"
                  render={renderProps => (
                    // <img
                    //   onClick={() =>
                    //     renderProps.onClick()
                    //   }
                    //   src="static/images/google.png"
                    // />
                    <button className="btn gmail"
                    onClick={() =>
                           !disabled && renderProps.onClick()
                         }>
                    <span className="sp-text">Gmail</span>{" "}
                    <span className="sp-icon">
                    <i class="fa fa-google-plus-square"></i>
                    </span>
                  </button>
                  )}
                  disabled={disabled}
                  onSuccess={responseGoogle}
                  onFailure={response => {}}
                  // cookiePolicy={"single_host_origin"}
                />
                </li>
                <li className="social-media-icon-btn">
                  <button className="btn twitter">
                    <span className="sp-text">Twitter</span>{" "}
                    <span className="sp-icon">
                      <i class="fa fa-twitter-square"></i>
                    </span>
                  </button>
                </li>
                <li className="social-media-icon-btn">
                  <button className="btn facebook">
                    <span className="sp-text">facebook</span>
                    <span className="sp-icon">
                      <i class="fa fa-facebook-square"></i>
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <div className="or-blk">
            <div className="or-absolute">
              <h5 className="text-uppercase">{props.t("or")}</h5>
            </div>
          </div> */}
          <div className="input-content-form">
            <Form
              className="login-form"
              onSubmit={e => {
                e.preventDefault();
                let data = {
                  firstName: e.target.firstName.value,
                  lastName: e.target.lastName.value,
                  email: e.target.email.value,
                  password: e.target.password.value,
                  phone: phone,
                  acceptedTerm: e.target.term.checked
                };
                if (!isValidPhoneNumber(data.phone)) {
                  toastr.error("Please enter valid phone number");
                  return;
                }
                // console.log(data);
                registerSubmit(data);
              }}
            >
              <Row>
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-2">
                    <Input
                      type="text"
                      name="firstName"
                      id="first_name"
                      required
                      placeholder={props.t("first_name")}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-2">
                    <Input
                      type="text"
                      name="lastName"
                      id="last_name"
                      required
                      placeholder={props.t("last_name")}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup className="custom-inputs with-icon mb-2">
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      required
                      maxLength={50}
                      placeholder={props.t("email")}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup className="custom-inputs with-icon mb-2">
                    <Input
                      type={eye ? "text" : "password"}
                      name="password"
                      id="password"
                      required
                      minLength={8}
                      placeholder={props.t("password")}
                    />
                    <div className="icons">
                      <svg
                        id="eye"
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.773"
                        height="20.3"
                        viewBox="0 0 29.773 20.3"
                        onClick={() => toggleEye()}
                      >
                        <g
                          id="Group_5705"
                          data-name="Group 5705"
                          transform="translate(0 0)"
                        >
                          <g
                            id="Group_5704"
                            data-name="Group 5704"
                            transform="translate(0 0)"
                          >
                            <path
                              id="Path_1"
                              data-name="Path 1"
                              d="M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z"
                              transform="translate(-159.84 -164.577)"
                              fill="#17468f"
                            />
                            <path
                              id="Path_2"
                              data-name="Path 2"
                              d="M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z"
                              transform="translate(0 -74.667)"
                              fill="#17468f"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col md={8}>
                  <FormGroup className="custom-inputs with-icon mb-0">
                    <PhoneInput
                      international
                      defaultCountry="JO"
                      name="phone"
                      id="phone"
                      value={phone}
                      placeholder="Phone Number"
                      onChange={value => {
                        setPhone(value);
                      }}
                    />
                  </FormGroup>
                </Col>
                {/* <Col md={4}>
                  <button className="btn w-100 mt-3 my-md-0">Verify</button>
                </Col> */}
              </Row>
              <Row className="align-items-center mt-3 ">
                <Col md={12}>
                  <div className="d-flex">
                    <span className="selction-box d-inline-flex">
                      <FormGroup className="checkboxes-list form-check ">
                        <Label check className="container-blk form-check-label">
                          <Input
                            type="checkbox"
                            name="term"
                            id="term"
                            required
                          />{" "}
                          <span className="checkmark"></span>
                        </Label>
                      </FormGroup>
                    </span>
                    <span className="terms-blk d-inline-flex">
                      {" "}
                      <h5>{props.t("term_use_statement")}</h5>
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="text-right mt-2 my-md-0">
                  <button className="btn btn-small ">
                    {props.t("register")}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </TabPane>
        <TabPane tabId="2">
          {/* <div className="social-media-btn input-content-form ">
            <h5>{props.t("login_using_social_media")}</h5>
            <div className="social-media-icon-tab">
              <ul className="social-media-icon-block text-center">
                <li className="social-media-icon-btn">
                  <button className="btn facebook">
                    <span className="sp-text">Face Book</span>{" "}
                    <span className="sp-icon">
                      <i class="fa fa-facebook-square"></i>
                    </span>
                  </button>
                </li>
                <li className="social-media-icon-btn">
                  <button className="btn twitter">
                    <span className="sp-text">Twitter</span>{" "}
                    <span className="sp-icon">
                      <i class="fa fa-twitter-square"></i>
                    </span>
                  </button>
                </li>
                <li className="social-media-icon-btn">
                  <button className="btn gmail">
                    <span className="sp-text">Gmail</span>
                    <span className="sp-icon">
                      <i class="fa fa-google-plus-square"></i>
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="or-blk">
            <div className="or-absolute">
              <h5 className="text-uppercase">{props.t("or")}</h5>
            </div>
          </div> */}
          <div className="input-content-form">
            <Form
              className="login-form"
              onSubmit={e => {
                e.preventDefault();
                loginSubmit(e.target.email.value, e.target.password.value);
              }}
            >
              <Row>
                <Col md={12}>
                  <FormGroup className="custom-inputs with-icon mb-2">
                    <Input
                      type="text"
                      name="email"
                      id="email"
                      placeholder={props.t("email")}
                      maxLength={50}
                      required
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup className="custom-inputs with-icon">
                    <Input
                      type={eye ? "text" : "password"}
                      name="password"
                      minLength={8}
                      id="password"
                      required
                      placeholder={props.t("password")}
                    />
                    <div className="icons">
                      <svg
                        id="eye"
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.773"
                        height="20.3"
                        viewBox="0 0 29.773 20.3"
                        onClick={() => toggleEye()}
                      >
                        <g
                          id="Group_5705"
                          data-name="Group 5705"
                          transform="translate(0 0)"
                        >
                          <g
                            id="Group_5704"
                            data-name="Group 5704"
                            transform="translate(0 0)"
                          >
                            <path
                              id="Path_1"
                              data-name="Path 1"
                              d="M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z"
                              transform="translate(-159.84 -164.577)"
                              fill="#17468f"
                            />
                            <path
                              id="Path_2"
                              data-name="Path 2"
                              d="M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z"
                              transform="translate(0 -74.667)"
                              fill="#17468f"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="align-items-center mb-3 ">
                <Col md={12} className="text-right">
                  <div class="forget-password-link">
                    <a
                      class="h4 c-pointer"
                      onClick={() => {
                        props.toggleLogin();
                        props.toggleForgot();
                      }}
                    >
                      {props.t("forgot_password")}
                    </a>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="text-right">
                  <button className="btn btn-small " type="submit">
                    {props.t("login")}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Example;
